import { Card, Skeleton, Row, Col } from 'antd'

export function TableSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <Card>
      <Skeleton active title={false} paragraph={{ rows: 1, width: ['30%'] }} />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton
          key={i}
          active
          title={false}
          paragraph={{ rows: 1, width: ['100%'] }}
          style={{ marginTop: 8 }}
        />
      ))}
    </Card>
  )
}

export function StatsGridSkeleton({ count = 4 }: { count?: number }) {
  return (
    <Row gutter={[16, 16]}>
      {Array.from({ length: count }).map((_, i) => (
        <Col key={i} xs={24} sm={12} md={6}>
          <Card>
            <Skeleton active title paragraph={{ rows: 2 }} />
          </Card>
        </Col>
      ))}
    </Row>
  )
}

export function ChartSkeleton({ height = 240 }: { height?: number }) {
  return (
    <Card>
      <Skeleton.Input active block style={{ height, width: '100%' }} />
    </Card>
  )
}
